import * as React from 'react';

const ArrowUpIcon = ({ size = 24, color = '#21262D' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.79289 10.5476C4.40237 10.9381 4.40237 11.5711 4.79289 11.9617C5.18342 12.3522 5.81643 12.3522 6.20696 11.9617L10.4999 7.6687L10.4999 20.2546C10.4999 20.8069 10.9476 21.2546 11.4999 21.2546C12.0522 21.2546 12.4999 20.8069 12.4999 20.2546L12.4999 7.6687L16.7929 11.9617C17.1834 12.3522 17.8164 12.3522 18.207 11.9617C18.5975 11.5711 18.5975 10.9381 18.207 10.5476L12.207 4.54761C11.8164 4.15708 11.1834 4.15708 10.7929 4.54761L4.79289 10.5476Z"
        fill={color}
      />
    </svg>
  );
};

ArrowUpIcon.propTypes = {};

ArrowUpIcon.defaultProps = {};

export default React.memo(ArrowUpIcon);
